import { Enumeration } from '../../utils/AppEnum';

export class ApprovalType extends Enumeration<ApprovalType> {

    public static Other = new ApprovalType("Other", 1);

    public static AI_Manager = new ApprovalType("EntAI Approval", 2);

    public static AVD_Manager = new ApprovalType("AVD Approval", 3);

    public static AKI_ACI_Manager = new ApprovalType("Container Approval", 4);
}
